import cn from "classnames";
import NoteContentItem from "../NoteContentItem/NoteContentItem";
import { formatDate } from "../../../../utils/helpers";
import { GENERAL_UPDATE_NOTE_LABELS } from "../../../../utils/constants";
import { IAddendumDetails } from "../../../../modules/notes/types/notes.types";
import useGetDiagnosisCodeToDisplay from "../../../../modules/notes/hooks";
import { useGetDiagnosisCodesDisplay } from "../../../../hooks/helpers";
import styles from "../../../../modules/notes/components/NoteContent/NoteContent.module.scss";
import CheckIcon from "../../../../icons/Check";

interface ViewGeneralNotesProps {
    noteContent: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
    };
    fieldAddendums: {
        [key: string]: IAddendumDetails[];
    } | null;
}
export default function ViewGeneralNote({
    noteContent,
    fieldAddendums,
}: ViewGeneralNotesProps) {
    const diagonosisCodes = useGetDiagnosisCodesDisplay(
        noteContent.diagnosis_codes
    );
    return (
        <>
            <NoteContentItem
                addendums={fieldAddendums?.update_note_content}
                headerText={GENERAL_UPDATE_NOTE_LABELS.update_note_content}
                fieldId="update_note_content"
                content={noteContent?.update_note_content || "--"}
            />
            <NoteContentItem
                headerText={GENERAL_UPDATE_NOTE_LABELS.diagnosis_codes}
                fieldId="diagnosis_codes"
                addendums={fieldAddendums?.diagnosis_codes}
                content={
                    diagonosisCodes && Array.isArray(diagonosisCodes) ? (
                        <div className={styles.checkboxes}>
                            {diagonosisCodes.map((code) => (
                                <div className={styles.checkbox} key={code}>
                                    <span
                                        className={cn(styles.checkbox_wrap, {
                                            [styles.checked]: true,
                                        })}
                                    >
                                        <CheckIcon className="stroke-text" />
                                    </span>
                                    {code}
                                </div>
                            ))}
                        </div>
                    ) : (
                        "--"
                    )
                }
            />
            <NoteContentItem
                headerText={GENERAL_UPDATE_NOTE_LABELS.secondary_diagnosis}
                fieldId="secondary_diagnosis"
                addendums={fieldAddendums?.secondary_diagnosis}
                content={useGetDiagnosisCodeToDisplay(
                    noteContent.secondary_diagnosis
                )}
            />
            <NoteContentItem
                headerText={GENERAL_UPDATE_NOTE_LABELS.tertiary_diagnosis}
                fieldId="tertiary_diagnosis"
                addendums={fieldAddendums?.tertiary_diagnosis}
                content={useGetDiagnosisCodeToDisplay(
                    noteContent.tertiary_diagnosis
                )}
            />
            <NoteContentItem
                headerText={GENERAL_UPDATE_NOTE_LABELS.additional_diagnosis_one}
                fieldId="additional_diagnosis_one"
                addendums={fieldAddendums?.additional_diagnosis_one}
                content={useGetDiagnosisCodeToDisplay(
                    noteContent.additional_diagnosis_one
                )}
            />
            <NoteContentItem
                headerText={GENERAL_UPDATE_NOTE_LABELS.additional_diagnosis_two}
                fieldId="additional_diagnosis_two"
                addendums={fieldAddendums?.additional_diagnosis_two}
                content={useGetDiagnosisCodeToDisplay(
                    noteContent.additional_diagnosis_two
                )}
            />
            <NoteContentItem
                headerText={GENERAL_UPDATE_NOTE_LABELS.date_of_update}
                fieldId="date_of_update"
                addendums={fieldAddendums?.date_of_update}
                content={
                    noteContent.date_of_update
                        ? formatDate(noteContent.date_of_update, true)
                        : "--"
                }
            />
        </>
    );
}
